import { APIPath } from "../constant";
import { BaseService } from "./base";
import { CRUDService } from "./crud";

class CustomLayer extends CRUDService {
  constructor() {
    super(APIPath.customLayers);
  }

  upload(data) {
    return BaseService.uploadFile(APIPath.customLayerUpload, data);
  }

  delete(key) {
    return BaseService.remove(`${APIPath.geoLayers}/${key}`);
  }

  export(data, obj) {
    return BaseService.post(
      `${APIPath.geoLayers}/${data?.key}?bbox=${data?.bbox}&zoom=${data?.zoom}&exportdata=${data?.exportdata}`,
      obj
    );
  }

  request(data) {
    return BaseService.post(`${APIPath.customLayersRequest}`, data);
  }
}
const CustomLayerService = new CustomLayer();
Object.freeze(CustomLayerService);
export { CustomLayerService };
